"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionType = exports.TaxType = exports.XeroAccountType = void 0;
var XeroAccountType;
(function (XeroAccountType) {
    XeroAccountType[XeroAccountType["BANK"] = 0] = "BANK";
    XeroAccountType[XeroAccountType["CURRENT"] = 1] = "CURRENT";
    XeroAccountType[XeroAccountType["CURRLIAB"] = 2] = "CURRLIAB";
    XeroAccountType[XeroAccountType["DEPRECIATN"] = 3] = "DEPRECIATN";
    XeroAccountType[XeroAccountType["DIRECTCOSTS"] = 4] = "DIRECTCOSTS";
    XeroAccountType[XeroAccountType["EQUITY"] = 5] = "EQUITY";
    XeroAccountType[XeroAccountType["EXPENSE"] = 6] = "EXPENSE";
    XeroAccountType[XeroAccountType["FIXED"] = 7] = "FIXED";
    XeroAccountType[XeroAccountType["INVENTORY"] = 8] = "INVENTORY";
    XeroAccountType[XeroAccountType["LIABILITY"] = 9] = "LIABILITY";
    XeroAccountType[XeroAccountType["NONCURRENT"] = 10] = "NONCURRENT";
    XeroAccountType[XeroAccountType["OTHERINCOME"] = 11] = "OTHERINCOME";
    XeroAccountType[XeroAccountType["OVERHEADS"] = 12] = "OVERHEADS";
    XeroAccountType[XeroAccountType["PREPAYMENT"] = 13] = "PREPAYMENT";
    XeroAccountType[XeroAccountType["REVENUE"] = 14] = "REVENUE";
    XeroAccountType[XeroAccountType["SALES"] = 15] = "SALES";
    XeroAccountType[XeroAccountType["TERMLIAB"] = 16] = "TERMLIAB";
    XeroAccountType[XeroAccountType["PAYGLIABILITY"] = 17] = "PAYGLIABILITY";
    XeroAccountType[XeroAccountType["PAYG"] = 18] = "PAYG";
    XeroAccountType[XeroAccountType["SUPERANNUATIONEXPENSE"] = 19] = "SUPERANNUATIONEXPENSE";
    XeroAccountType[XeroAccountType["SUPERANNUATIONLIABILITY"] = 20] = "SUPERANNUATIONLIABILITY";
    XeroAccountType[XeroAccountType["WAGESEXPENSE"] = 21] = "WAGESEXPENSE";
})(XeroAccountType = exports.XeroAccountType || (exports.XeroAccountType = {}));
var TaxType;
(function (TaxType) {
    TaxType[TaxType["OUTPUT"] = 0] = "OUTPUT";
    TaxType[TaxType["INPUT"] = 1] = "INPUT";
    TaxType[TaxType["CAPEXINPUT"] = 2] = "CAPEXINPUT";
    TaxType[TaxType["EXEMPTEXPORT"] = 3] = "EXEMPTEXPORT";
    TaxType[TaxType["EXEMPTEXPENSES"] = 4] = "EXEMPTEXPENSES";
    TaxType[TaxType["EXEMPTCAPITAL"] = 5] = "EXEMPTCAPITAL";
    TaxType[TaxType["EXEMPTOUTPUT"] = 6] = "EXEMPTOUTPUT";
    TaxType[TaxType["INPUTTAXED"] = 7] = "INPUTTAXED";
    TaxType[TaxType["BASEXCLUDED"] = 8] = "BASEXCLUDED";
    TaxType[TaxType["GSTONCAPIMPORTS"] = 9] = "GSTONCAPIMPORTS";
    TaxType[TaxType["GSTONIMPORTS"] = 10] = "GSTONIMPORTS";
    TaxType[TaxType["NONE"] = 11] = "NONE";
    TaxType[TaxType["INPUT2"] = 12] = "INPUT2";
    TaxType[TaxType["ZERORATED"] = 13] = "ZERORATED";
    TaxType[TaxType["OUTPUT2"] = 14] = "OUTPUT2";
    TaxType[TaxType["CAPEXINPUT2"] = 15] = "CAPEXINPUT2";
    TaxType[TaxType["CAPEXOUTPUT"] = 16] = "CAPEXOUTPUT";
    TaxType[TaxType["CAPEXOUTPUT2"] = 17] = "CAPEXOUTPUT2";
    TaxType[TaxType["CAPEXSRINPUT"] = 18] = "CAPEXSRINPUT";
    TaxType[TaxType["CAPEXSROUTPUT"] = 19] = "CAPEXSROUTPUT";
    TaxType[TaxType["ECACQUISITIONS"] = 20] = "ECACQUISITIONS";
    TaxType[TaxType["ECZRINPUT"] = 21] = "ECZRINPUT";
    TaxType[TaxType["ECZROUTPUT"] = 22] = "ECZROUTPUT";
    TaxType[TaxType["ECZROUTPUTSERVICES"] = 23] = "ECZROUTPUTSERVICES";
    TaxType[TaxType["EXEMPTINPUT"] = 24] = "EXEMPTINPUT";
    TaxType[TaxType["REVERSECHARGES"] = 25] = "REVERSECHARGES";
    TaxType[TaxType["RRINPUT"] = 26] = "RRINPUT";
    TaxType[TaxType["RROUTPUT"] = 27] = "RROUTPUT";
    TaxType[TaxType["SRINPUT"] = 28] = "SRINPUT";
    TaxType[TaxType["SROUTPUT"] = 29] = "SROUTPUT";
    TaxType[TaxType["ZERORATEDINPUT"] = 30] = "ZERORATEDINPUT";
    TaxType[TaxType["ZERORATEDOUTPUT"] = 31] = "ZERORATEDOUTPUT";
    TaxType[TaxType["BLINPUT"] = 32] = "BLINPUT";
    TaxType[TaxType["DSOUTPUT"] = 33] = "DSOUTPUT";
    TaxType[TaxType["EPINPUT"] = 34] = "EPINPUT";
    TaxType[TaxType["ES33OUTPUT"] = 35] = "ES33OUTPUT";
    TaxType[TaxType["ESN33OUTPUT"] = 36] = "ESN33OUTPUT";
    TaxType[TaxType["IGDSINPUT2"] = 37] = "IGDSINPUT2";
    TaxType[TaxType["IMINPUT2"] = 38] = "IMINPUT2";
    TaxType[TaxType["MEINPUT"] = 39] = "MEINPUT";
    TaxType[TaxType["NRINPUT"] = 40] = "NRINPUT";
    TaxType[TaxType["OPINPUT"] = 41] = "OPINPUT";
    TaxType[TaxType["OSOUTPUT"] = 42] = "OSOUTPUT";
    TaxType[TaxType["TXESSINPUT"] = 43] = "TXESSINPUT";
    TaxType[TaxType["TXN33INPUT"] = 44] = "TXN33INPUT";
    TaxType[TaxType["TXPETINPUT"] = 45] = "TXPETINPUT";
    TaxType[TaxType["TXREINPUT"] = 46] = "TXREINPUT";
    TaxType[TaxType["INPUT3"] = 47] = "INPUT3";
    TaxType[TaxType["INPUT4"] = 48] = "INPUT4";
    TaxType[TaxType["OUTPUT3"] = 49] = "OUTPUT3";
    TaxType[TaxType["OUTPUT4"] = 50] = "OUTPUT4";
    TaxType[TaxType["SROUTPUT2"] = 51] = "SROUTPUT2";
    TaxType[TaxType["TXCA"] = 52] = "TXCA";
    TaxType[TaxType["SRCAS"] = 53] = "SRCAS";
    TaxType[TaxType["BLINPUT2"] = 54] = "BLINPUT2";
    TaxType[TaxType["DRCHARGESUPPLY20"] = 55] = "DRCHARGESUPPLY20";
    TaxType[TaxType["DRCHARGE20"] = 56] = "DRCHARGE20";
    TaxType[TaxType["DRCHARGESUPPLY5"] = 57] = "DRCHARGESUPPLY5";
    TaxType[TaxType["DRCHARGE5"] = 58] = "DRCHARGE5";
})(TaxType = exports.TaxType || (exports.TaxType = {}));
var TransactionType;
(function (TransactionType) {
    TransactionType["CREDIT"] = "CREDIT";
    TransactionType["DEBIT"] = "DEBIT";
})(TransactionType = exports.TransactionType || (exports.TransactionType = {}));
//# sourceMappingURL=accounting.js.map